import { Fragment } from 'react';
import { Divider } from '@chakra-ui/react';

const SectionHandler = ({ index, child, count }) => {
    return (
        <Fragment key={index}>
            {child}
            {index < count - 1 && (
                <Divider
                    borderColor="#F5F5F5"
                    borderWidth="1.4px"
                    sx={{
                        margin: '0 !important',
                        marginTop: '10px !important',
                    }}
                />
            )}
        </Fragment>
    );
};

export default SectionHandler;
